<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { RadioGroupRoot } from 'reka-ui'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import { GradeType } from '~/models/GradeType'
import Button from '~/components/ui/Button.vue'
import AuRadio from '~/components/ui/AuRadio.vue'
import VgsGradeSelectorPopover from '~/components/settings/VgsGradeSelectorPopover.vue'

const { t } = useI18n()
const authStore = useAuthStore()
const { selectedGradeType } = storeToRefs(authStore)

const currentGradeType = computed({
  get: () => selectedGradeType.value,
  set: grade => grade && authStore.setGradeType(grade)
})
</script>

<template>
  <div>
    <p
      class="text-gray-50"
      v-text="t('filters.chooseGradeType')"
    />
    <RadioGroupRoot
      v-model="currentGradeType"
      as="fieldset"
      class="mt-6 flex flex-wrap gap-3"
    >
      <Button
        v-for="gradeType in GradeType"
        :key="gradeType"
        variant="outline"
        type="label"
      >
        <AuRadio
          shade="dark"
          :value="gradeType"
        />
        {{ t(`metadata.gradeTypes.${gradeType}`) }}
        <VgsGradeSelectorPopover
          v-if="gradeType === GradeType.GradeVgs"
          shade="dark"
        />
      </Button>
    </RadioGroupRoot>
  </div>
</template>
